import { IsArray, IsNotEmpty, IsObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { NomenclaturePositionChildUpdateRequest } from './nomenclature-position-child-update.request';

interface NomenclaturePositionUpdateRequestRaw {
    uuid?: string;
    nomTypeUuid?: string;
    values?: Record<string, unknown>;
    childPositions?: Partial<NomenclaturePositionChildUpdateRequest>[];
}

/**
 * @see NomenclaturePosition from backend/src/sharable/nomenclature/nomenclature-position.ts
 */
export class NomenclaturePositionUpdateRequest {
    @IsOptional()
    @IsString()
    @IsNotEmpty()
    public uuid?: string;

    @IsString()
    @IsNotEmpty()
    public nomTypeUuid: string;

    @IsObject()
    public values: Record<string, unknown>; // See TaxonomyValues from backend/src/sharable/taxonomy/taxonomy-values.ts

    @IsArray()
    @ValidateNested({ each: true })
    public childPositions: NomenclaturePositionChildUpdateRequest[];

    constructor(data?: NomenclaturePositionUpdateRequestRaw) {
        this.uuid = data?.uuid ?? undefined;
        this.nomTypeUuid = data?.nomTypeUuid ?? undefined;
        this.values = data?.values;
        this.childPositions = Array.isArray(data?.childPositions)
            ? data.childPositions.map(childPosition => new NomenclaturePositionChildUpdateRequest(childPosition))
            : data?.childPositions;
    }
}
